/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knotty_Vivid_Tortoise_ViewInputs */

const fr_knotty_vivid_tortoise_view = /** @type {(inputs: Knotty_Vivid_Tortoise_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packages`)
};

/**

* @param {Knotty_Vivid_Tortoise_ViewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const knotty_vivid_tortoise_view = /** @type {((inputs?: Knotty_Vivid_Tortoise_ViewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knotty_Vivid_Tortoise_ViewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_knotty_vivid_tortoise_view(inputs)
});